import { Certificate } from "../../Certificate";

interface CompanyFormProps {
  handleChange: (event: any) => void;
  isDateInvoiceActive: string;
  data: Certificate;
}

export default function CompanyForm({
  handleChange,
  isDateInvoiceActive,
  data,
}: CompanyFormProps) {
  const certMode = isDateInvoiceActive === "date";
  const invoiceMode = isDateInvoiceActive === "date_invoice";
  const disabledClass =
    "disabled:bg-[#f0f0f0] disabled:text-[#9a9a9a]";

  return (
    <>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor={"date"}>
          дата выпуска сертификата<span className="text-red-600">*</span>
        </label>
        <input
          type="date"
          required={certMode}
          name="date"
          id="date"
          onChange={(event) => handleChange(event)}
          minLength={4}
          disabled={invoiceMode}
          value={data.date || ""}
          className={`px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] ${disabledClass}`}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="certification_number">
          номер сертификата
          {certMode && <span className="text-red-600">*</span>}
        </label>
        <input
          type="text"
          name="certification_number"
          id="certification_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          required={certMode}
          disabled={invoiceMode}
          className={`px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] ${disabledClass}`}
          value={data.certification_number || ""}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="date_invoice">
          дата выпуска накладной<span className="text-red-600">*</span>
        </label>
        <input
          type="date"
          required={invoiceMode}
          name="date_invoice"
          id="date_invoice"
          onChange={(event) => handleChange(event)}
          minLength={4}
          disabled={certMode}
          value={data.date_invoice || ""}
          className={`px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] ${disabledClass}`}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="gov_number">номер вагона (гос. номер)</label>
        <input
          type="text"
          name="gov_number"
          id="gov_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          disabled={certMode}
          className={`px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] ${disabledClass}`}
          value={data.gov_number || ""}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="delivery_number">номер поставки</label>
        <input
          type="text"
          name="delivery_number"
          id="delivery_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4]"
          value={data.delivery_number || ""}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="invoice_number">номер накладной</label>
        <input
          type="text"
          name="invoice_number"
          id="invoice_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4]"
          value={data.invoice_number || ""}
        />
      </div>
      <div className="flex flex-col w-full sm:w-[48%] text-left">
        <label htmlFor="contractor">контрагент (ИНН)</label>
        <input
          type="text"
          name="contractor"
          id="contractor"
          onChange={(event) => handleChange(event)}
          minLength={4}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4]"
          value={data.contractor || ""}
        />
      </div>
    </>
  );
}
